import {
    AR_AGING_BUCKET_LABELS,
    ArAgingBucket,
} from "@common/types/reports/ar-aging";
import { PreviewArAgingDetailDataset } from "../previewTypes";

export const AR_AGING_DETAIL_DATASET: PreviewArAgingDetailDataset = {
    shape: "ar-aging-detail",
    dateHeader: "Date",
    customerHeader: "Customer",
    dueDateHeader: "Due date",
    amountHeader: "Amount",
    openHeader: "Open",
    percentHeader: "% of total",
    percentBase: 1216850.5,
    rows: [
        {
            id: "current",
            kind: "section",
            label: AR_AGING_BUCKET_LABELS[ArAgingBucket.CURRENT],
            bucket: ArAgingBucket.CURRENT,
        },
        {
            id: "current-northwind",
            kind: "line",
            label: "Northwind Co",
            bucket: ArAgingBucket.CURRENT,
            dateOffset: -20,
            dueDateOffset: 10,
            amount: 520000,
            open: 520000,
        },
        {
            id: "current-acme",
            kind: "line",
            label: "Acme Corp",
            bucket: ArAgingBucket.CURRENT,
            dateOffset: -12,
            dueDateOffset: 18,
            amount: 640000,
            open: 480000,
        },
        {
            id: "current-subtotal",
            kind: "subtotal",
            label: "Subtotal",
            bucket: ArAgingBucket.CURRENT,
            amount: 1160000,
            open: 1000000,
            hasTopBorder: true,
        },
        {
            id: "days-1-30",
            kind: "section",
            label: AR_AGING_BUCKET_LABELS[ArAgingBucket.DAYS_1_TO_30],
            bucket: ArAgingBucket.DAYS_1_TO_30,
        },
        {
            id: "days-1-30-hooli",
            kind: "line",
            label: "Hooli",
            bucket: ArAgingBucket.DAYS_1_TO_30,
            dateOffset: -50,
            dueDateOffset: -22,
            amount: -12500,
            open: -9000,
        },
        {
            id: "days-1-30-initech",
            kind: "line",
            label: "Initech",
            bucket: ArAgingBucket.DAYS_1_TO_30,
            dateOffset: -45,
            dueDateOffset: -14,
            amount: 84200,
            open: 84200,
        },
        {
            id: "days-1-30-subtotal",
            kind: "subtotal",
            label: "Subtotal",
            bucket: ArAgingBucket.DAYS_1_TO_30,
            amount: 71700,
            open: 75200,
            hasTopBorder: true,
        },
        {
            id: "days-31-60",
            kind: "section",
            label: AR_AGING_BUCKET_LABELS[ArAgingBucket.DAYS_31_TO_60],
            bucket: ArAgingBucket.DAYS_31_TO_60,
        },
        {
            id: "days-31-60-northwind-collected",
            kind: "line",
            label: "Northwind Co",
            bucket: ArAgingBucket.DAYS_31_TO_60,
            dateOffset: -75,
            dueDateOffset: -52,
            amount: 120000,
            open: 0,
        },
        {
            id: "days-31-60-northwind-open",
            kind: "line",
            label: "Northwind Co",
            bucket: ArAgingBucket.DAYS_31_TO_60,
            dateOffset: -75,
            dueDateOffset: -52,
            amount: 36400,
            open: 36400,
        },
        {
            id: "days-31-60-acme",
            kind: "line",
            label: "Acme Corp",
            bucket: ArAgingBucket.DAYS_31_TO_60,
            dateOffset: -70,
            dueDateOffset: -38,
            amount: 15250.5,
            open: 15250.5,
        },
        {
            id: "days-31-60-subtotal",
            kind: "subtotal",
            label: "Subtotal",
            bucket: ArAgingBucket.DAYS_31_TO_60,
            amount: 171650.5,
            open: 51650.5,
            hasTopBorder: true,
        },
        {
            id: "days-91-plus",
            kind: "section",
            label: AR_AGING_BUCKET_LABELS[ArAgingBucket.DAYS_91_AND_OVER],
            bucket: ArAgingBucket.DAYS_91_AND_OVER,
        },
        {
            id: "days-91-plus-hooli",
            kind: "line",
            label: "Hooli",
            bucket: ArAgingBucket.DAYS_91_AND_OVER,
            dateOffset: -150,
            dueDateOffset: -102,
            amount: 90000,
            open: 90000,
        },
        {
            id: "days-91-plus-subtotal",
            kind: "subtotal",
            label: "Subtotal",
            bucket: ArAgingBucket.DAYS_91_AND_OVER,
            amount: 90000,
            open: 90000,
            hasTopBorder: true,
        },
        {
            id: "total",
            kind: "total",
            label: "Total",
            amount: 1493350.5,
            open: 1216850.5,
            hasTopBorder: true,
        },
    ],
};
